import React, { useEffect, useState } from 'react';
import './EcoregionCallout.css';
import Button from '../ui/Button';
import USStateHeatMap from '../maps/USStateHeatMap';
import { fetchDesignCountsByState } from '../../utils/designStatsUtils';

const EcoregionCallout = () => {
  const [countsByState, setCountsByState] = useState({});
  const [totalDesigns, setTotalDesigns] = useState(0);
  const [statesWithDesigns, setStatesWithDesigns] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const loadDesignCounts = async () => {
      try {
        const stats = await fetchDesignCountsByState();
        if (!active) {
          return;
        }

        setCountsByState(stats.countsByState);
        setTotalDesigns(stats.total);
        setStatesWithDesigns(stats.statesWithDesigns);
      } catch (error) {
        console.error('Failed to load design counts by state:', error);
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadDesignCounts();

    return () => {
      active = false;
    };
  }, []);

  const summaryText = loading
    ? 'Loading community designs across the U.S...'
    : totalDesigns > 0
      ? `${totalDesigns} community design${totalDesigns === 1 ? '' : 's'} across ${statesWithDesigns} state${statesWithDesigns === 1 ? '' : 's'}.`
      : 'Be the first to map your environment. Designs will appear here as the community grows.';

  return (
    <section className="ecoregion-callout">
      <div className="ecoregion-callout__content">
        <h2>Be unique.</h2>
        <p>
          1,512 distinct ecoregions across the world. There is a pattern out there for every one.
        </p>
        <p className="ecoregion-callout__stats">{summaryText}</p>
      </div>
      <div className="ecoregion-callout__map">
        <USStateHeatMap
          stateData={countsByState}
          variant="heatmap"
          showTooltip
          interactive={false}
          seamless
          className="us-state-heatmap--seamless"
        />
      </div>
      <div className="ecoregion-callout__button">
        <Button
          variant="primary"
          onClick={() => window.open('https://shop.cultcamo.com', '_blank', 'noopener,noreferrer')}
        >
          SHOP
        </Button>
      </div>
    </section>
  );
};

export default EcoregionCallout;
